import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0a7e5918"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "animate"
}
const _hoisted_3 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_4 = { class: "modal-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Antes de escribir una nueva pregunta...", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", { style: {"font-size":"14px"} }, "¿Has comprobado si la pregunta que vas a realizar ya se ha hecho anteriormente?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Antes de abrir una nueva cuestión, verifica que esta no se ha realizado antes. Es posible que algún compañero se haya enfrentado a un problema similar en el pasado, y esta duda ya se encuentre resuelta. Si no es el caso, ¡Es hora de preguntar a los compañeros! :)")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "new-question" }, "He comprobado que no existe una duda igual. ¡Preguntemos a la compañeros!", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Listado de Preguntas", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = { class: "search-form" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_13 = { class: "table-container" }
const _hoisted_14 = { class: "modern-table" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Resuelta", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Pregunta", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Seleccionar", -1))
const _hoisted_19 = { key: 0 }

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import CourseService from '@/services/CourseService'
import LessonService from '@/services/LessonService';
import ForumService from '@/services/ForumService';
import { onMounted, ref, Ref } from 'vue';
import { useRoute } from 'vue-router';
import useWindowWidth from '@/composables/useWindowWidth';
import main from '@/data/main.js';
import ForumI from '@/interfaces/ForumInterface';
import CourseI from '@/interfaces/CourseInterface';
import LessonI from '@/interfaces/LessonInterface'
//import AdvertisementMain from '@/components/advertisement/AdevertisementMain.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ForumDetailView',
  setup(__props) {

const service = new CourseService()
const lessonService = new LessonService()
const forumService = new ForumService()
const items: Ref<ForumI[]> = ref([])
const filtered: Ref<ForumI[]> = ref([])
const loading = ref(true)
const search = ref('')
const course:Ref<CourseI> = ref({})
const lesson:Ref<LessonI> = ref({})
const route = useRoute()
const course_id = route.params.course_id
const lesson_id = route.params.lesson_id
const showAdvice = ref(false)
const { windowWidth } = useWindowWidth()
const tableSmall = ref(600)

onMounted(async () => {
    loading.value = true
    course.value = await service.GetCourse(course_id)
    lesson.value = await lessonService.getLesson(lesson_id)
    items.value = await forumService.GetQuestionsByLessonId(lesson_id);
    filtered.value = items.value;
    loading.value = false
})

const handleSearch = () => {
    loading.value = true
    filtered.value = items.value.filter(item => item.name?.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (showAdvice.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      style: {"float":"right","cursor":"pointer"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showAdvice.value = false))
                    }, [
                      _createVNode(_component_v_icon, {
                        name: "ri-close-circle-fill",
                        fill: "lightcoral"
                      })
                    ]),
                    _hoisted_5,
                    (_unref(windowWidth) >= 1000)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(main).RESPONSE_GENERAL_LIST,
                          style: {"width":"100%"}
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    _hoisted_7,
                    _createVNode(_component_RouterLink, {
                      to: { name: 'write-question-course', params: { course_id: _unref(course_id), lesson_id: _unref(lesson_id) } },
                      style: {"text-decoration":"none"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_9,
            _createVNode(_component_RouterLink, {
              to: { name: 'forum' },
              class: "breadcrumbs"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Dudas y Preguntas")
              ]),
              _: 1
            }),
            _createTextVNode(" / "),
            _createVNode(_component_RouterLink, {
              to: { name: 'forum-course' },
              class: "breadcrumbs"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cursos")
              ]),
              _: 1
            }),
            _createTextVNode(" / "),
            _createVNode(_component_RouterLink, {
              to: { name: 'forum-course-list', params: { course_id: _unref(course_id) } },
              class: "breadcrumbs"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(course.value.name), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createTextVNode(" / " + _toDisplayString(lesson.value?.name) + " ", 1),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "new-question",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showAdvice.value = true))
              }, [
                _createVNode(_component_v_icon, {
                  name: "bi-plus-circle-fill",
                  style: {"margin-right":"10px"}
                }),
                _createTextVNode(" Crear una nueva Pregunta / Duda")
              ])
            ]),
            _hoisted_10,
            _createElementVNode("form", _hoisted_11, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
                placeholder: "Escribe aquí para filtrar.",
                onKeyup: handleSearch,
                class: "input-job"
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_15,
                    _hoisted_16,
                    (_unref(windowWidth) > tableSmall.value)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_17, "Fecha"))
                      : _createCommentVNode("", true),
                    _hoisted_18
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        (item?.is_solved == '0')
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              name: "ri-forbid-fill",
                              fill: "#ccc",
                              scale: "2"
                            }))
                          : _createCommentVNode("", true),
                        (item?.is_solved == '1')
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              name: "bi-check-circle-fill",
                              fill: _unref(main).THIRD_COLOR,
                              scale: "2"
                            }, null, 8, ["fill"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      (_unref(windowWidth) > tableSmall.value)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(item.updated_at ? `${new Date(item.updated_at).getDate()}/${new
            Date(item.updated_at).getMonth() + 1}/${new Date(item.updated_at).getFullYear()}` : ''), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", null, [
                        _createVNode(_component_RouterLink, {
                          to: { name: 'detail-question-lessons-course', params: { course_id: course.value.id, lesson_id: item.lesson_id, question_id: item.id } }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              name: "md-fileopen-round",
                              class: "ver",
                              fill: _unref(main).SECONDARY_COLOR,
                              scale: "2"
                            }, null, 8, ["fill"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})